import { render, staticRenderFns } from "./bo-carousel.vue?vue&type=template&id=1cb5b250"
import script from "./bo-carousel.vue?vue&type=script&lang=js"
export * from "./bo-carousel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports